<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="New Operations Audit">
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>

        <!--Filter header start -->
        <v-row justify-end>
          <v-col cols="6" md="6"></v-col>
          <v-col cols="6" md="6" right>
            <v-row>
              <v-col>
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom @click="saveAsDraft" right elevation="1" color="primary"
                    type="button">
                    <v-icon left> mdi-content-save </v-icon>
                    Save as draft
                  </v-btn>
                </v-card-actions>
              </v-col>
              <v-col>
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right @click="submitAudit" elevation="1" color="primary"
                    type="submit">
                    Submit Audit
                  </v-btn>
                </v-card-actions>
              </v-col>
              <v-col>
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right @click="saveAsCloseAudit" elevation="1" color="primary"
                    type="button">
                    Close Audit
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete label="Select acadamic year *" clearable
              v-model="formData.academicYearID" :items="acadamicYearData" key="id" item-value="id"
              item-text="academicYear">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete label="Select Center" v-model="formData.franchiseeID" clearable
              :items="centreList" key="id" item-value="id" item-text="companyName">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <div class="control audit-date">
              <input class="input" type="date" v-model="formData.auditDate" required disabled />
            </div>

          </v-col>

        </v-row>

        <!--Filter header end -->
        <form autocomplete="off" @submit.prevent="save">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-card flat class="pb-12">
                <v-card-text>
                  <v-tabs v-model="categoriesTabs" background-color="" center-active>
                    <v-tabs-slider color=""></v-tabs-slider>
                    <v-tab v-for="item in categoryTab" :key="item.id">
                      {{ item.categoryName }}
                    </v-tab>
                  </v-tabs>
                  <v-divider class="my-0"></v-divider>
                  <v-tabs-items v-model="categoriesTabs">
                    <v-tab-item v-for="(item, catIndex) in categoryTab" :key="item.id">

                      <v-expansion-panels focusable>
                        <v-expansion-panel v-for="(subcat, subIndex) in item.subCategory"
                          :key="subcat.id">
                          <v-expansion-panel-header>{{ subcat.subCategoryName }}
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <br />
                            <h5 v-if="subcat.parameter.length === 0">No parameters available</h5>
                            <div v-for="(prm, prmIndex) in subcat.parameter" :key="prm.id">
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <h3 class="v-list-item__title font-weight-regular title">
                                    {{ prm.parameterName }}</h3>
                                </v-col>
                                <v-col col="6" md="6">
                                  <label class="font-weight-medium body-2">
                                    Response Type
                                  </label>
                                  <v-autocomplete key="value"
                                    v-model="categoryTab[catIndex].subCategory[subIndex].parameter[prmIndex].responseId"
                                    label="Select Response" :items="responseLists"
                                    @change="onChangeResponse()" item-text="responseType"
                                    item-value="id" required>
                                  </v-autocomplete>
                                </v-col>

                                <v-col cols="6" md="6"
                                  v-if="constant && getResponseTypeById(categoryTab[catIndex].subCategory[subIndex].parameter[prmIndex].responseId) === constant.GENERAL_AUDIT.response.no">
                                  <div class="field">
                                    <v-row>
                                      <v-col cols="12" md="6">
                                        <div>
                                          <label class="font-weight-medium body-2">
                                            No. of Days
                                          </label>

                                          <v-autocomplete key="value" label="Select Days"
                                            :items="numberOptions"
                                            v-model="categoryTab[catIndex].subCategory[subIndex].parameter[prmIndex].tat"
                                            item-text="nText" item-value="value"> </v-autocomplete>
                                        </div>
                                      </v-col>

                                    </v-row>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>

                                <v-col cols="6" md="6">
                                  <label class="font-weight-medium body-2">Select File </label>
                                  <span class="has-text-danger">Allowed
                                    files: .pdf, .png, .jpg, .jpeg. </span>
                                  <span class="has-text-danger"> File that are not
                                    supported will be removed automatically!</span>

                                  <v-file-input small-chips v-model="prm.files" multiple
                                    @change="onFilechange(prm.files)" placeholder="Click to Upload"
                                    :messages="['(max file size allowed 100MB)']"
                                    accept=".pdf,.png,.jpeg,.jpg"></v-file-input>

                                  <div v-if="prm.files.length > 0">
                                   <v-chip v-for="(file, i) in prm.files" :key="i" color="primary"
                                      label multiple outlined class="ma-2" close
                                      @click:close="deleteDropFile(prm.files, i)">
                                      {{ file.name }}
                                    </v-chip>
                                  </div>

                                </v-col>
                                <v-col class="pl-0 pr-0" cols="6" md="6">

                                  <label class="font-weight-medium body-2">Remarks</label><br />
                                  <v-text-field label="Enter Remark"
                                    v-model="categoryTab[catIndex].subCategory[subIndex].parameter[prmIndex].remark "
                                    placeholder="Ex: A">
                                  </v-text-field>
                                </v-col>

                              </v-row>
                              <br /><br />
                              <hr role="separator" aria-orientation="horizontal"
                                class="my-0 v-divider theme--light" />
                              <br />
                            </div>

                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import _ from 'lodash'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['type'],
  async created () {
    this.constant = constants
    console.log(constants.GENERAL_AUDIT, 'constants.GENERAL_AUDIT')
    await this.getAcadamicYearsList()
    await this.getFranchisee()
    this.getCategoriesList()
    this.getResponseList()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      this.franchiseeID = val.id
    },

    academicYear: async function (val) {
      this.academicYearID = val.id
    }
  },
  data () {
    return {
      franchiseeID: '',
      centreList: [],
      // franchiseeOptions: [],
      constant: null,
      isWrite: true,
      academicYearID: '',
      acadamicYearData: [],
      status: '',
      categoriesTabs: [],
      category: [],
      categoryLists: [],
      categoryTab: [],
      subCategoryLists: [],
      parameterList: [],
      responseLists: [],
      responseType: '',
      responseTypeID: '',
      selectedResponseTypeID: '',
      myDate: null,
      isPublished: '',
      dropFile: null,
      auditDataCopy: [],
      min: 0,
      max: 100,

      numberOptions: [
        { nText: '1', value: '1' },
        { nText: '2', value: '2' },
        { nText: '3', value: '3' },
        { nText: '4', value: '4' },
        { nText: '5', value: '5' },
        { nText: '6', value: '6' },
        { nText: '7', value: '7' },
        { nText: '8', value: '8' },
        { nText: '9', value: '9' },
        { nText: '10', value: '10' },
        { nText: '11', value: '12' },
        { nText: '13', value: '13' },
        { nText: '14', value: '14' },
        { nText: '15', value: '15' }
      ],

      allowedFiles: ['pdf', 'jpg', 'png', 'jpeg'],
      date: new Date().toISOString().substr(0, 7),
      menu: false,

      modal: false,
      formData: {
        academicYearID: '',
        franchiseeID: '',
        auditDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        isPublish: false,
        isActive: true,
        status: ''
      },
      validationErrors: {
        academicYearID: 'Academic Year ID',
        franchiseeID: 'Center',
        auditDate: 'Audit date'
      }
    }
  },
  methods: {
    getResponseTypeById (responseId) {
      let searchIndex = this.responseLists.map(item => item.id).indexOf(responseId)
      let responseType = searchIndex > -1 ? this.responseLists[searchIndex].responseType.toString().toLowerCase() : null
      return responseType
    },
    // Draft Save Method
    saveAsDraft: async function () {
      try {
        if (this.draftValidation()) {
          // let parameter = []
          let subCategoryFiles = []
          let category = this.categoryTab.map(item => {
            let mainCategory = {
              auditCategoryID: item.id,
              categoryScore: 0,
              // overallRemark: '',
              subCategories: []
            }
            mainCategory.subCategories = item.subCategory.map(sub => {
              let subCategory = {
                subCategoryID: sub.id
              }
              subCategory.parameters = sub.parameter.map(prm => {
                let searchIndex = _.map(this.responseLists, a => a.id).indexOf(prm.responseId)
                subCategoryFiles.push({
                  categoryID: item.id,
                  subCategoryID: sub.id,
                  parameterID: prm.id,
                  files: prm.files
                })
                return {
                  parameterID: prm.id,
                  responseId: prm.responseId,
                  // score: prm.score,
                  tat: prm.tat,
                  position: prm.position,
                  remark: prm.remark,
                  status: this.responseLists[searchIndex] ? this.responseLists[searchIndex].responseType : '',
                  isActive: true
                  // files: prm.files
                }
              })
              return subCategory
            })
            return mainCategory
          })
          let obj = {
            academicYearID: this.formData.academicYearID,
            franchiseeID: this.formData.franchiseeID,
            auditDate: this.formData.auditDate,
            isPublish: false, // Draft
            isActive: true,
            status: 'IN-PROGRESS',
            categories: category
          }
          const { data } = await http.post(`${constants.API_URL}/api/audit/addaudit`, obj)
          if (data) {
            for (let category of data.auditCategoryMaps) {
              for (let subCategory of category.SubCategory) {
                let filesObject = subCategoryFiles.find(obj => obj.parameterID === subCategory.auditParameterID)
                if (filesObject && filesObject.files.length) {
                  let response = await this.saveParameterFiles(filesObject.files, subCategory.id)
                  console.log('Files save ersponse', response)
                }
              }
            }
          }
          this.okMsg('Audit saved in draft successfully!!')
          this.$router.push({ name: 'generalAuditDraftList' })
        } else {
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    draftValidation () {
      let message = ''
      if (!this.formData.academicYearID) {
        message = 'Please select a Year'
      } else if (!this.formData.franchiseeID) {
        message = 'Please select center'
      } else if (!this.formData.auditDate) {
        message = 'Please select a audit date'
      } else if (!this.formData.franchiseeID) {
        message = 'Please select a center.'
      } else if (!this.formData.auditDate) {
        message = 'Please select a audit date.'
      } else if (this.categoryTab.length === 0) {
        message = 'There are no parameters to audit'
      }
      if (message !== '') {
        this.$buefy.toast.open({
          message: message,
          type: 'is-danger',
          duration: 4000
        })
      }
      return message === ''
    },

    getFranchisee: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.centreList = res.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getCategoriesList: async function () {
      try {
        this.isLoading = true
        let categoryLists = await http.get(`${constants.API_URL}/api/audit/audit-category/get`)
        this.categoryLists = categoryLists.data

        this.categoryTab = categoryLists.data.rows.map(item => {
          item.subCategory.forEach(subCategory => {
            subCategory.parameter.forEach(prm => {
              prm.responseId = ''
              prm.remark = ''
              prm.files = []
              // prm.files = ''
              // prm.score = 0
              // prm.tat = prm.tat
              // prm.tat = moment(prm.startDate).diff(prm.endDate, 'days')
            })
          })
          return item
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getResponseList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/audit/audit-response/getall`)
        this.responseLists = data
        this.responseTypeID = this.responseLists.id
        this.isLoading = false
        return this.responseList
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getAcadamicYearsList: async function () {
      let rows = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`, {
        params: {
          isCurrentAcademicYear: true
        }
      })
      this.acadamicYearData = rows.data.rows
      this.formData.academicYearID = this.acadamicYearData[1] ? this.acadamicYearData[1].id : ''
    },

    onFilechange (files) {
      let r = files.filter((a, i) => {
        if (this.allowedFiles.includes(a.name.split('.').pop())) {
        }
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.files = r
      this.$forceUpdate()
    },
    deleteDropFile (files, i) {
      files.splice(i, 1)
    },
    async saveParameterFiles (files, auditSubCategoryMapID) {
      try {
        this.isLoading = true
        let formData = new FormData()
        for (let i = 0; i < this.files.length; i++) {
          formData.append('files', this.files[i])
        }
        formData.append('auditSubCategoryMapID', auditSubCategoryMapID)
        let res = await http.post(`${constants.API_URL}/api/audit/add-audit-files`, formData)
        return res.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return errorMessage
      } finally {
        this.isLoading = false
      }
    },
    // Save Methods
    // submit audit
    submitAudit: async function () {
      try {
        if (this.submitValidation(this.categoryTab)) {
          let subCategoryFiles = []
          // console.log(this.categoryTab, 'test')
          let category = this.categoryTab.map(item => {
            let mainCategory = {
              auditCategoryID: item.id,
              categoryScore: 0,
              // overallRemark: '',
              subCategories: []
            }
            mainCategory.subCategories = item.subCategory.map(sub => {
              let subCategory = {
                subCategoryID: sub.id
              }
              subCategory.parameters = sub.parameter.map(prm => {
                let searchIndex = _.map(this.responseLists, a => a.id).indexOf(prm.responseId)
                subCategoryFiles.push({
                  categoryID: item.id,
                  subCategoryID: sub.id,
                  parameterID: prm.id,
                  files: prm.files
                })
                return {
                  parameterID: prm.id,
                  responseId: prm.responseId,
                  // score: prm.score,
                  tat: 0,
                  position: prm.position,
                  remark: prm.remark,
                  status: this.responseLists[searchIndex] ? this.responseLists[searchIndex].responseType : '',
                  isActive: true
                  // files: prm.files
                }
              })
              return subCategory
            })
            return mainCategory
          })
          let obj = {
            academicYearID: this.formData.academicYearID,
            franchiseeID: this.formData.franchiseeID,
            auditDate: this.formData.auditDate,
            isPublish: true,
            isActive: true,
            status: 'COMPLETED',
            categories: category
          }

          const { data } = await http.post(`${constants.API_URL}/api/audit/addaudit`, obj)
          console.log(data)
          if (data) {
            for (let category of data.auditCategoryMaps) {
              for (let subCategory of category.SubCategory) {
                let filesObject = subCategoryFiles.find(obj => obj.parameterID === subCategory.auditParameterID)
                if (filesObject && filesObject.files.length) {
                  let response = await this.saveParameterFiles(filesObject.files, subCategory.id)
                  console.log('Files save ersponse', response)
                }
              }
            }
          }
          this.okMsg('Audit completed successfully!!')
          this.$router.push({ name: 'generalAudits' })
        } else {
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    submitValidation (categories) {
      let message = ''
      if (!this.formData.academicYearID) {
        this.errMsg('Please select a Year')
        return false
      } else if (!this.formData.franchiseeID) {
        this.errMsg('Please select center')
        return false
      } else if (!this.formData.auditDate) {
        this.errMsg('Please select a audit date')
        return false
      } else if (!this.formData.franchiseeID) {
        this.errMsg('Please select a center.')
        return false
      }

      for (let c of categories) {
        for (let s of c.subCategory) {
          for (let p of s.parameter) {
            // console.log(`${this.responseTypeGet(p.responseId)}====${this.constant.GENERAL_AUDIT.response.no}`)
            if (!p.responseId) {
              this.errMsg('Complete reponse to submit the audit.')
              return false
            }
            let responseType = this.getResponseTypeById(p.responseId)
            if (responseType === this.constant.GENERAL_AUDIT.response.no && !p.tat) {
              this.errMsg('Please select number of days')
              return false
            } else if (responseType === this.constant.GENERAL_AUDIT.response.no && p.tat) {
              this.errMsg('Please complete all audit parameters or wait till number of days are complete.')
              return false
            }
          }
        }
      }
      if (message !== '') {
        this.$buefy.toast.open({
          message: message,
          type: 'is-danger',
          duration: 4000
        })
      }
      return message === ''
    },
    // end
    // close audit
    saveAsCloseAudit: async function () {
      try {
        if (this.closeValidation(this.categoryTab)) {
          // let parameter = []
          let subCategoryFiles = []
          let category = this.categoryTab.map(item => {
            let mainCategory = {
              auditCategoryID: item.id,
              categoryScore: 0,
              // overallRemark: '',
              subCategories: []
            }
            mainCategory.subCategories = item.subCategory.map(sub => {
              let subCategory = {
                subCategoryID: sub.id
              }

              subCategory.parameters = sub.parameter.map(prm => {
                let searchIndex = _.map(this.responseLists, a => a.id).indexOf(prm.responseId)
                subCategoryFiles.push({
                  categoryID: item.id,
                  subCategoryID: sub.id,
                  parameterID: prm.id,
                  files: prm.files
                })
                return {
                  parameterID: prm.id,
                  responseId: prm.responseId,
                  // score: prm.score,
                  tat: prm.tat,
                  position: prm.position,
                  remark: prm.remark,
                  status: this.responseLists[searchIndex] ? this.responseLists[searchIndex].responseType : '',
                  isActive: true
                  // files: prm.files
                }
              })
              return subCategory
            })
            return mainCategory
          })
          let obj = {
            academicYearID: this.formData.academicYearID,
            franchiseeID: this.formData.franchiseeID,
            auditDate: this.formData.auditDate,
            isPublish: false,
            isActive: true,
            status: 'CLOSED',
            categories: category
          }

          const { data } = await http.post(`${constants.API_URL}/api/audit/addaudit`, obj)

          if (data) {
            for (let category of data.auditCategoryMaps) {
              for (let subCategory of category.SubCategory) {
                let filesObject = subCategoryFiles.find(obj => obj.parameterID === subCategory.auditParameterID)
                if (filesObject && filesObject.files.length) {
                  let response = await this.saveParameterFiles(filesObject.files, subCategory.id)
                  console.log('Files save ersponse', response)
                }
              }
            }
          }
          this.okMsg('Audit closed successfully!!')
          this.$router.push({ name: 'auditClosures' })
        } else {
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    closeValidation (categories) {
      let message = ''
      if (!this.formData.academicYearID) {
        this.errMsg('Please select a Year')
        return false
      } else if (!this.formData.franchiseeID) {
        this.errMsg('Please select center')
        return false
      } else if (!this.formData.auditDate) {
        this.errMsg('Please select a audit date')
        return false
      } else if (!this.formData.franchiseeID) {
        this.errMsg('Please select a center.')
        return false
      }

      for (let c of categories) {
        for (let s of c.subCategory) {
          for (let p of s.parameter) {
            // console.log(`${this.responseTypeGet(p.responseId)}====${this.constant.GENERAL_AUDIT.response.no}`)
            if (!p.responseId) {
              this.errMsg('Complete reponse to submit the audit.')
              return false
            }
            let responseType = this.getResponseTypeById(p.responseId)
            if (responseType === this.constant.GENERAL_AUDIT.response.no && !p.tat) {
              this.errMsg('Please select number of days')
              return false
            } else if (responseType === this.constant.GENERAL_AUDIT.response.no && p.tat) {
              this.errMsg('Please complete all audit parameters or wait till number of days are complete.')
              return false
            }
          }
        }
      }
      if (message !== '') {
        this.$buefy.toast.open({
          message: message,
          type: 'is-danger',
          duration: 4000
        })
      }
      return message === ''
    },
    onChange (e) {},
    onChangeResponse () {
      this.$forceUpdate()
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    // End of Save Methods
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  }
}
</script>

<style scoped>
.add-audit-offline {
  position: absolute;
  right: 150px;
  top: 18px;
}
.add-audit-online {
  position: absolute;
  right: 180px;
  top: 0;
}
.audit-date {
  padding-top: 10px;
}
input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}
</style>
